import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Display-only formatting: "2026-07-30" (or a full timestamp like
// "2026-07-30T14:22:01.123Z") -> "30-Jul-2026". Storage, API payloads, and
// backend input-hash computation are untouched - this never round-trips.
// Parses the YYYY-MM-DD prefix directly instead of `new Date(iso)`, which
// would parse a date-only string as UTC midnight and can render as the
// previous day in negative-UTC-offset timezones.
export function formatDate(iso) {
  if (!iso) return '';
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(iso));
  if (!match) return iso;
  const [, year, month, day] = match;
  const monthIndex = parseInt(month, 10) - 1;
  if (monthIndex < 0 || monthIndex > 11) return iso;
  return `${day}-${MONTH_ABBR[monthIndex]}-${year}`;
}
